/* Privacy-friendly page analytics, chosen at build time.

   REACT_APP_ANALYTICS_PROVIDER  cloudflare (default) | plausible | none
   REACT_APP_CF_ANALYTICS_TOKEN  Cloudflare Web Analytics site token
   REACT_APP_PLAUSIBLE_DOMAIN    site domain as registered in Plausible
   REACT_APP_PLAUSIBLE_SRC       script URL (default https://plausible.io/js/script.js)

   Neither provider sets cookies. Both track client-side route changes on their
   own (Cloudflare via "spa": true, Plausible via History API hooks), so the
   router needs no extra wiring. Nothing loads in development or without the
   provider's token/domain. */
function addScript(attrs) {
  const s = document.createElement('script');
  s.defer = true;
  Object.entries(attrs).forEach(([k, v]) => s.setAttribute(k, v));
  document.head.appendChild(s);
}

export function initAnalytics() {
  if (process.env.NODE_ENV !== 'production') return;
  const provider = (process.env.REACT_APP_ANALYTICS_PROVIDER || 'cloudflare').toLowerCase();

  if (provider === 'cloudflare') {
    const token = process.env.REACT_APP_CF_ANALYTICS_TOKEN;
    if (!token) return;
    addScript({
      src: 'https://static.cloudflareinsights.com/beacon.min.js',
      'data-cf-beacon': JSON.stringify({ token, spa: true }),
    });
  } else if (provider === 'plausible') {
    const domain = process.env.REACT_APP_PLAUSIBLE_DOMAIN;
    if (!domain) return;
    addScript({
      src: process.env.REACT_APP_PLAUSIBLE_SRC || 'https://plausible.io/js/script.js',
      'data-domain': domain,
    });
  }
}
